import React, {useState} from 'react';
import { useQuotes } from '../../Data/Quotes';
import Loading from '../../Components/Loading';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Section, { Sections } from '../../Components/Containers/Section';
import { getEntityLink, plural, useRedirect } from '../../Services/helpers';
import { Link } from 'react-router-dom';
import Title from '../../Components/Formatting/Customer/Title';
import Subtitle from '../../Components/Formatting/Customer/Subtitle';
import Search, { useSearch } from '../../Components/Search';
import NoItems from '../../Components/EmptyStates/NoItems';
import QuoteSearch from './Search';
import Button from '../../Components/Button/Button';
import AddQuote from './AddQuote';

const Quotes = () => {
    const [addingQuote, setAddingQuote] = useState(false);
    const {go, Redirect} = useRedirect();

    return <Search data={{closed: false}} persist="quotes:search">
        <TopBar title="Quotes" right={<Button theme="light" icon="Plus" onClick={() => setAddingQuote(true)} zeroMargin />} />

        <Page>
            <Inner />
        </Page>

        <AddQuote isOpen={addingQuote}
            setIsOpen={setAddingQuote}
            onAdded={(data) => go(getEntityLink('Quotes/Quote', data.quoteId))}
        />
        <Redirect />
    </Search>
}

const Inner = () => {

    const {searchDebounced, hasSearchConditions, liveSearch} = useSearch();
    const {isLoading, quotes, newQuotes, laterQuotes, expectingQuotes, oldQuotes} = useQuotes(searchDebounced, true);

    return <>
        <QuoteSearch isLoading={isLoading} />
        {isLoading && <Loading size="4x" center className="mt-4" />}

        {!isLoading && <Sections className="mt-6">
            {liveSearch(newQuotes).length > 0 ? <Group title="New" quotes={liveSearch(newQuotes)} /> : null}
            {liveSearch(laterQuotes).length > 0 ? <Group title="Later" quotes={liveSearch(laterQuotes)} /> : null}
            {liveSearch(expectingQuotes).length > 0 ? <Group title="Expecting" quotes={liveSearch(expectingQuotes)} /> : null}
            {liveSearch(oldQuotes).length > 0 ? <Group title="Old" quotes={liveSearch(oldQuotes)} /> : null}
            {(liveSearch(quotes).length === 0 && hasSearchConditions === false) && <NoItems icon="User" title="No quotes" className="mt-4" />}
            {(liveSearch(quotes).length === 0 && hasSearchConditions === true) && <p className="text-muted text-center mt-5">No quotes match your search</p>}
        </Sections>}
    </>;
}

const Group = ({title, quotes}) => {
    return <Section title={title}>
        <ul className="divide-y divide-gray-200 mt-0">
            {quotes.map(quote => <Quote key={quote.id} quote={quote} />)}
        </ul>
    </Section>
}

const Quote = ({quote}) => {
    return <li className="flex items-center justify-between gap-x-6 py-5 first:pt-0">
        <Link to={getEntityLink('Quotes/Quote', quote.id)} className="w-full block">
            <div className="min-w-0">
                <div className="flex items-start gap-x-3">
                    <p className="leading-6 text-gray-900">
                        <Title className="font-semibold" customer={quote} />
                        <br />
                        <Subtitle customer={quote} />
                    </p>
                </div>
                <div className="mt-1 flex items-center gap-x-2 leading-5 text-gray-500">
                    <p className="whitespace-nowrap">
                        {quote.status}
                    </p>

                    <p className="text-red-600 ml-3">
                        {plural(quote.unreadMessages, null, '1 Message', `${quote.unreadMessages} Messages`)}
                    </p>
                </div>
            </div>
        </Link>
        <div className="flex flex-none items-center gap-x-4">
            {/* <Dropdown options={[]} /> */}
        </div>
    </li>
}

export default Quotes;
